import { LineScaleMode } from '@awayjs/renderer';
import { JointStyle } from './JointStyle';
import { CapsStyle } from './CapsStyle';
var GraphicsStrokeStyle = /** @class */ (function () {
    function GraphicsStrokeStyle(fillStyle, thickness, jointstyle, capstyle, miterLimit, scaleMode) {
        if (thickness === void 0) { thickness = 10; }
        if (jointstyle === void 0) { jointstyle = JointStyle.ROUND; }
        if (capstyle === void 0) { capstyle = CapsStyle.SQUARE; }
        if (miterLimit === void 0) { miterLimit = 10; }
        if (scaleMode === void 0) { scaleMode = LineScaleMode.NORMAL; }
        this.fillStyle = fillStyle;
        this.thickness = thickness;
        this.jointstyle = jointstyle;
        this.capstyle = capstyle;
        this.miterLimit = miterLimit;
        this.scaleMode = scaleMode;
    }
    Object.defineProperty(GraphicsStrokeStyle.prototype, "half_thickness", {
        get: function () {
            return this.thickness / 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphicsStrokeStyle.prototype, "data_type", {
        get: function () {
            return GraphicsStrokeStyle.data_type;
        },
        enumerable: false,
        configurable: true
    });
    GraphicsStrokeStyle.prototype.clone = function () {
        return new GraphicsStrokeStyle(this.fillStyle, this.thickness, this.jointstyle, this.capstyle, this.miterLimit, this.scaleMode);
    };
    GraphicsStrokeStyle.data_type = '[graphicsdata StrokeStyle]';
    return GraphicsStrokeStyle;
}());
export { GraphicsStrokeStyle };
